import { render, staticRenderFns } from "./RenderingContentAlgoliaSearch.vue?vue&type=template&id=5ac18a5a"
import script from "./RenderingContentAlgoliaSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./RenderingContentAlgoliaSearch.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports